const validateName = ({ value, required, minLength })=>{
    if (required && value === "") return "\u0412\u0432\u0435\u0434\u0438\u0442\u0435, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0412\u0430\u0448\u0435 \u0438\u043C\u044F";
    if (minLength && minLength > value.length) return `\u{41C}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435} \u{43A}\u{43E}\u{43B}\u{438}\u{447}\u{435}\u{441}\u{442}\u{432}\u{43E} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{43E}\u{432} ${minLength}`;
    return "";
};
// https://regex101.com/r/pMUvPe/4
const EMAIL_REGEX = /^([\w!#$%&'*+./=?^`{|}~-]+)?[\w!#$%&'*+/=?^`{|}~-]@[\dA-Za-z-]+()(\.[\dA-Za-z-]+)*(\.[A-Za-z]+)$/;
const validateEmail = ({ value, required, pattern = EMAIL_REGEX })=>{
    const errorMessage = "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 email";
    if (required && value === "") return errorMessage;
    if (value && !pattern.test(value)) return errorMessage;
    return "";
};
const renderError = (inputElement, errorElement, errorMessage)=>{
    if (errorMessage) inputElement.focus();
    if (errorElement.classList.contains("error")) errorElement.innerHTML = errorMessage;
};
const checkValidationForm = (formSelector)=>{
    const inputName = document.querySelector(`${formSelector} .form__input--user input`);
    const inputEmail = document.querySelector(`${formSelector} .form__input--email input`);
    const form = document.querySelector(formSelector);
    form.addEventListener("submit", (e)=>{
        const nextNameSibling = inputName.nextElementSibling;
        const nextEmailSibling = inputEmail.nextElementSibling;
        const errorNameMessage = validateName({
            value: inputName.value,
            required: true,
            minLength: 2
        });
        const errorEmailMessage = validateEmail({
            value: inputEmail.value,
            required: true
        });
        if (errorNameMessage || errorEmailMessage) {
            e.preventDefault();
            renderError(inputName, nextNameSibling, errorNameMessage);
            renderError(inputEmail, nextEmailSibling, errorEmailMessage);
            form.querySelector("input[name=name]").addEventListener("input", (e)=>{
                const errorMessage = validateName({
                    value: e.target.value,
                    required: true,
                    minLength: 2
                });
                renderError(inputName, nextNameSibling, errorMessage);
            });
            form.querySelector("input[name=email]").addEventListener("input", (e)=>{
                const errorMessage = validateEmail({
                    value: e.target.value,
                    required: true
                });
                renderError(inputEmail, nextEmailSibling, errorMessage);
            });
        }
    });
};
checkValidationForm(".validate-one");
checkValidationForm(".validate-two");
const handleFocusByClick = ()=>{};
document.querySelector("#start").addEventListener("click", (e)=>{
    e.preventDefault();
    document.querySelector("#order").scrollIntoView({
        behaviour: "smooth"
    });
    document.querySelector("#first-name-focus").focus();
});

//# sourceMappingURL=freewebdev.min.js.map
